import { default as Endpoint } from '../../api/Endpoint';
import * as Constants from '../constants';

export function requestImports() {
  return {
    type: Constants.REQUEST_IMPORTS
  };
}
export function receiveImports(json, error) {
  return {
    type: Constants.RECEIVE_IMPORTS,
    data: json,
    error
  };
}

export function receiveUpdatedImport(json) {
  return {
    type: Constants.RECEIVE_UPDATED_IMPORT,
    data: json
  };
}

export function getImports(options = {}) {
  const path = 'ecs/api/import?type=DeImport';
  return new Endpoint(path, requestImports, receiveImports)
    .withOptions(options)
    .call();
}
